<template>
  <div v-if="isOpenDialog">
    <v-card
      height="640px">
      <v-card-title class="text-h6 pt-5 pb-4">
        {{selectedTerms.termsTitle}}
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text class="px-4 cardArea">
        <div style="height: 100%;" v-dompurify-html="selectedTerms.termsContent"></div>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="py-3 px-6">
          <v-row>
            <v-col cols="4" md="3">
              <v-btn
                @click="closeDialog()"
                elevation="0"
                large
                block
              >
                {{ $t('signup.btn.cancel') }}
              </v-btn>
            </v-col>
            <v-col cols="8" md="9">
              <v-btn
                @click="agreeTerms()" 
                v-model="selectedTerms.agreed"
                elevation="0"
                color="secondary"
                large
                block
              >
              {{ $t('signup.btn.agree_terms') }}
              </v-btn>
            </v-col>
          </v-row>
      </v-card-actions>
    </v-card>
  </div>
  <!-- 약관 페이지 -->
  <div v-else class="TermsPage">
    <v-col 
      cols="12" md="8" lg="6" xl="4" 
      class="pa-0 ">
      <v-card height="100vh" tile class="elevation-0">
      <v-card-title class="text-h6 pt-5 pb-4">
        {{selectedTerms.termsTitle}}
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text class="px-4 cardArea2">
        <div style="height: 100%;" v-dompurify-html="selectedTerms.termsContent"></div>
      </v-card-text>
      </v-card>
    </v-col>
  </div>

</template>

<script>
import {
  $getActiveTerms,
} from "@/redcrm/api/terms.js";

export default {
    props:{
        termsCode:String,
        isOpenDialog:Boolean
    },
    data(){
        return{
            selectedTerms:{}
        }
    },
    methods:{
        async getActiveTerms(){
            try {
                const termsCode = this.termsCode;
                const { data } = await $getActiveTerms(termsCode);
                this.selectedTerms = data.result
            } catch (error) {
               this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
            }
        },
        closeDialog(){
            this.$emit("closeDialog");
        },
        agreeTerms(){
            this.$emit("agreeTerms")
        }
    },
    mounted(){
        this.getActiveTerms();
    }
}
</script>

<style lang="scss" scoped>
iframe{
  width: 100%;
  height: 100%;
  border: none;
}

.cardArea{
  height: calc(100% - 68px - 92px)
}

.TermsPage{
  display: flex; 
  justify-content: center;
  background-color: #f1f3f5;
  width: 100%;
}

.cardArea2{
  height: calc(100% - 69px)
}

</style>